import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";
import {filterDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template';
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class facebookContentComparison_template extends vnTemplate{

    public dimensionFilter: filterDropdown_template;
    public pageFilter : multipleSelector_template;
    public dateFilter: filterDate_template;
    public comparisonDateFilter: filterDate_template;
    public contentTypeFilter : multipleSelector_template;
    public intentFilter : multipleSelector_template;
    public primaryCategoryFilter : filterAutoComplete_template;
    public networkCategoryFilter : multipleSelector_template;
    public headers: simpleListHeader_template;
    public presetFilter: presetFilter_template;

    protected getTemplateHtml(): string {
        // TODO make sure to check the module for this if we decide to keep this report, I commented out things that were causing errors.
        return `
            <div class="sub-header w-justify"> </div>
            <div class="list-header w-justify">
                <div class="w-left">
                    <h2 class="section-title icon i-compare">Facebook Content Comparison</h2>
                </div>
            </div>
            <div style="position: absolute;width: 100%;height: 100%;margin: 0 auto">
                <p style="text-align: center;position: relative;font-family:  'Lato', sans-serif; font-size: 1.8rem; font-weight: 1000; color: #085070; display: inline-block;">This report no longer exists. Please contact Kaleb M. and Ginn A. with any questions you may have.</p>
            </div>
        `;
    }

    /*protected getTemplateHtml(): string{

        return `
            <div class="sub-header w-justify">

                ` + this.presetFilter.getHtmlBuild() + `
     
                <div class="w-left">
                    <div>
                        <label class="form-label" for="">Dimension</label>
                        ${this.dimensionFilter.getHtmlBuild()}
                    </div>
                    <div>
                        ${this.pageFilter.getHtmlBuild()}
                    </div>
                     <div>
                        ${this.networkCategoryFilter.getHtmlBuild()}
                    </div>
                     <div>
                        ${this.contentTypeFilter.getHtmlBuild()}
                    </div>
                   
                    <div class="ww-date-picker">
                        <label class="form-label" for="">Date</label>
                        ${this.dateFilter.getHtmlBuild()}
                    </div>
                    <div class="ww-date-picker">
                        <label class="form-label" for="">Comparison Date</label>
                        ${this.comparisonDateFilter.getHtmlBuild()}
                    </div>
                   
                    <div>
                        ${this.intentFilter.getHtmlBuild()}
                    </div>
                    <div>
                        ${this.primaryCategoryFilter.getHtmlBuild()}
                    </div>
                    
                </div>
               
            </div>
            
            
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-pages"></div>
                    <div id="selected-content-types"></div>
                    <div id="selected-intents"></div>
                    <div id="selected-network-categories"></div>
                </div>
            </div>
            
            <div id="list-results" data-bind="css: { loading: isLoading }">
                <div class="list-header w-justify">
                    <div class="w-left">
                        <h2 class="section-title icon i-compare">Facebook Content Comparison</h2>
                    </div>
                </div>

               <div class="w-list-results">
                   <table class="list-results">
                        <thead> 
                            ` + this.headers.getHtmlBuild()  + `
                        </thead>
                        <tbody data-bind="foreach: data">
                            <tr>
                                <td>
                                    <span data-bind="text: dimension"></span>
                                </td>
                                <td>
                                    <span data-bind="text: Number(nbPosts).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                    <div data-bind="visible: $parent.isVisibleComparisonDate">
                                        <span data-bind="text: $parent.displayDiff(nbPostsDiff), style: { color: $parent.displayDiffColour(nbPostsDiff) }"></span>
                                    </div>
                                </td>
                                <td>
                                    <span data-bind="text: Number(clicksPerPost).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span>
                                    <div data-bind="visible: $parent.isVisibleComparisonDate">
                                        <span data-bind="text: $parent.displayDiff(clicksPerPostDiff), style: { color: $parent.displayDiffColour(clicksPerPostDiff) }"></span>
                                    </div>
                                </td>
                                <td>
                                    <span data-bind="text: Number(reachPerPost).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                    <div data-bind="visible: $parent.isVisibleComparisonDate">
                                        <span data-bind="text: $parent.displayDiff(reachPerPostDiff), style: { color: $parent.displayDiffColour(reachPerPostDiff) }"></span>
                                    </div>
                                </td>
                                <td>
                                    <span data-bind="text: Number(ctr).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span>
                                    <div data-bind="visible: $parent.isVisibleComparisonDate">
                                        <span data-bind="text: $parent.displayDiff(ctrDiff), style: { color: $parent.displayDiffColour(ctrDiff) }"></span>
                                    </div>
                                </td>
                                <td>
                                    <span data-bind="text: Number(engagementPerPost).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span>
                                    <div data-bind="visible: $parent.isVisibleComparisonDate">
                                        <span data-bind="text: $parent.displayDiff(engagementPerPostDiff), style: { color: $parent.displayDiffColour(engagementPerPostDiff) }"></span>
                                    </div>
                                </td>
                                
                            </tr>
                        <tbody>
                   </table>
               </div>
            </div>
        `;
    }*/

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return "facebookContentComparison_template";
    }

    /**
     * @inheritDoc
     */
    protected initPartial(): void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('facebookContentComparison');

        let headers = [
            {
                headerName: "DIMENSION", fieldName: "dimension", subHeaders: []
            },
            {
                headerName: "COUNT OF POSTS", fieldName: "nbPosts", subHeaders: []
            },
            {
                headerName: "CLICKS PER POST", fieldName: "clicksPerPost", subHeaders: []
            },
            {
                headerName: "REACH PER POST", fieldName: "reachPerPost", subHeaders: []
            },
            {
                headerName: "CTR", fieldName: "ctr", subHeaders: []
            },
            {
                headerName: "ENGAGEMENT PER POST", fieldName: "engagementPerPost", subHeaders: []
            },
        ];

        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, headers);

        this.dimensionFilter       = new filterDropdown_template('dimensionFilter', this.getTemplateViewModel(), this.caller);


        this.pageFilter = new multipleSelector_template("pageFilter", this.getTemplateViewModel(), this.caller);
        this.pageFilter.setLabel("Pages");
        this.pageFilter.setFilterContainerClass('margin-neg');
        this.pageFilter.setTagContainerId('selected-pages');
        this.pageFilter.setTagContainerCaption('Selected pages:');

        this.contentTypeFilter = new multipleSelector_template("contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.contentTypeFilter.setLabel("Content Types");
        this.contentTypeFilter.setFilterContainerClass('margin-neg');
        this.contentTypeFilter.setTagContainerId('selected-content-types');
        this.contentTypeFilter.setTagContainerCaption('Selected content types:');

        this.intentFilter = new multipleSelector_template("intentFilter", this.getTemplateViewModel(), this.caller);
        this.intentFilter.setLabel("Intents");
        this.intentFilter.setFilterContainerClass('margin-neg');
        this.intentFilter.setTagContainerId('selected-intents');
        this.intentFilter.setTagContainerCaption('Selected intents:');

        this.primaryCategoryFilter = new filterAutoComplete_template("primaryCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoryFilter.setIsVisible(1);
        this.primaryCategoryFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoryFilter.setIcon("i-tag-a");

        this.networkCategoryFilter = new multipleSelector_template("networkCategoryFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoryFilter.setLabel("Network Categories");
        this.networkCategoryFilter.setFilterContainerClass('margin-neg');
        this.networkCategoryFilter.setTagContainerId('selected-network-categories');
        this.networkCategoryFilter.setTagContainerCaption('Selected network categories:');

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        let endDate = new Date();
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - 13);

        this.dateFilter.setDateRange(startDate, endDate);

        this.comparisonDateFilter = new filterDate_template("comparisonDateFilter", this.getTemplateViewModel(), this.caller);
        let comparisonEndDate = new Date();
        let comparisonStartDate = new Date();
        comparisonEndDate.setDate(startDate.getDate() -1);
        comparisonStartDate.setDate(comparisonEndDate.getDate() - 13);
        this.comparisonDateFilter.setDateRange(comparisonStartDate, comparisonEndDate);
        this.comparisonDateFilter.setStartPickerId("comparissionStartPicker");
        this.comparisonDateFilter.setEndPickerId("comparissionEndPicker");
    }

    /**
     * @inheritDoc
     */
    public buildViewModel(){

        let self = this;

        return {
            isVisibleComparisonDate: ko.observable(true),
            brands: ko.observableArray([]),
            data: ko.observableArray(),
            isLoading: ko.observable(0),
            displayDiff: function(data){

                if('N/A' == data){

                    return data;
                }

                let sign = '';

                if(data >= 0){

                    sign = '+';
                }

                return `(${sign}${Number(data).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}%)`;
            },
            displayDiffColour: function(data){

                if('N/A' == data){

                    return 'inherit';
                }

                return (data < 0) ? 'red' : 'green';
            }
        };
    }

    /**
     * Returns request view model.
     */
    public getViewModelForRequest(){

        return {

            dimension: this.dimensionFilter.getTemplateViewModel().selectedOption(),
            pages: this.pageFilter.getTemplateViewModel().selectedItems(),
            contentTypes: this.contentTypeFilter.getTemplateViewModel().selectedItems(),
            intents: this.intentFilter.getTemplateViewModel().selectedItems(),
            primaryCategory: this.getTemplateViewModel().primaryCategoryFilter.idSelectedItem(),
            primaryCategoryName: this.getTemplateViewModel().primaryCategoryFilter.nameSelectedItem(),
            networkCategories: this.networkCategoryFilter.getTemplateViewModel().selectedItems(),
            dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().dateFilter.startDate(),
            endDate: this.getTemplateViewModel().dateFilter.endDate(),
            startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
            comparisonDateFilterType: this.getTemplateViewModel().comparisonDateFilter.selectedFilter(),
            comparisonStartDate: this.getTemplateViewModel().comparisonDateFilter.startDate(),
            comparisonEndDate: this.getTemplateViewModel().comparisonDateFilter.endDate(),
            comparisonStartDateRange: this.getTemplateViewModel().comparisonDateFilter.fromRange(),
            comparisonEndDateRange: this.getTemplateViewModel().comparisonDateFilter.toRange(),
            orderBy: this.headers.getTemplateViewModel().orderBy(),
            orderByDirection: this.headers.getTemplateViewModel().orderByDirection(),
        }
    }

    /**
     * Build the date Picker calendar
     */
    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
        this.comparisonDateFilter.buildCalendar();
    }

    public setDimensionFilterItem(){

        this.dimensionFilter.setOptions([
            { "id": 1, "name": "Facebook Page"},
            { "id": 2, "name": "Content type"},
            { "id": 3, "name": "Intent"},
            { "id": 4, "name": "Primary category"},
            { "id": 5, "name": "Network category"}
        ]);

        this.dimensionFilter.setSelectedOption(1);
    }

    public setPageFilterItems(pages){
        for (let item of pages){
            item['id'] = item['idAccount'];
        }
        this.pageFilter.setItems(pages);
    }

    public setContentTypeFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.contentTypeFilter.setMultiSectionItems(groups);
        this.contentTypeFilter.setLabel('Content Types');
    }

    public setPostIntentFilterItems(items){
        for (let item of items){
            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.intentFilter.setItems(items);
    }

    public setNetworkCategoryFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoryFilter.setMultiSectionItems(groups);
        this.networkCategoryFilter.setLabel('Network Categories');
    }

    public setPrimaryCategoryFilterItems(items){

        this.primaryCategoryFilter.setItems(items);
    }

    /**
     * Sets data for tables and summaries.
     *
     * @param data
     */
    public setData(data){

        this.getTemplateViewModel().data(data);
    }

    /**
     * Show loading effect.
     */
    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    /**
     * Hide loading effect.
     */
    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    public setViewModelFromRequest(params : Array<any>): void{

        this.presetFilter.setMultiSelectorPresetFilters(this.pageFilter, params['pages']);
        this.presetFilter.setMultiSelectorPresetFilters(this.contentTypeFilter, params['contentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.intentFilter, params['intents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoryFilter, params['networkCategories']);

        this.presetFilter.setAutocompletePresetFilter(this.primaryCategoryFilter, params['primaryCategory'], params['primaryCategoryName']);

        this.presetFilter.setDates(this.dateFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);

        this.presetFilter.setDates(this.comparisonDateFilter, params['comparisonDateFilterType'], params['comparisonStartDate'], params['comparisonEndDate'], params['comparisonStartDateRange'], params['comparisonEndDateRange']);

        if(typeof params['dimension'] !== 'undefined'){

            this.dimensionFilter.setSelectedOption(params['dimension']);
        }
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/facebookContentComparison_template.ts